import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/PproLogDetails/api/pproLogDetailsService'
import { PproLogDetailsState, ApiPproLogDetailsResponse } from './types'

const initialState: PproLogDetailsState = {
  data: {},
}

const pproLogDetailsSlice = createSlice({
  name: 'activityLogPproLogDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiPproLogDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = pproLogDetailsSlice.actions

export default pproLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
